import {Avatar as MantineAvatar} from '@mantine/core';

/**
 * User avatar (image or initials) — design-layer pass-through over Mantine `Avatar`.
 * @registry Pass-through Mantine Avatar; import this instead of @mantine/core outside src/design.
 */
export const Avatar = MantineAvatar;
